/**
 * One place that builds WebSocket URLs.
 *
 * Two things went wrong when each caller did this itself:
 *
 *  - Deriving the host from `window.location` points the socket at whatever served
 *    the page. Wherever front and back are split (CI, a dev server on another port,
 *    the Capacitor build) that is the static file server, which answers the upgrade
 *    with index.html and never connects. `ChatView` still had this after the same
 *    bug was fixed in `AuthContext`.
 *  - The token was easy to forget. Every socket authenticates via `?token=`, so the
 *    signature makes it a required argument rather than something to remember.
 */

/**
 * @param {string} path  socket path, e.g. "/ws/chat/chat_a_b"
 * @param {string} token JWT of the signed-in user
 */
export function wsUrl(path, token) {
  const backend = process.env.REACT_APP_BACKEND_URL;
  const origin = backend ? new URL(backend, window.location.origin) : window.location;
  const proto = origin.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${origin.host}${path}?token=${encodeURIComponent(token)}`;
}
